var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',[_vm._v("Comptes bancaires")]),_c('card',[_c('div',{staticClass:"grid grid-cols-1 lg:grid-cols-2 gap-4"},_vm._l((_vm.bankAccounts),function(account){return _c('accounting-bank-account-item',{key:account.account,attrs:{"account":account}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }